<form [formGroup]="configForm" novalidate (ngSubmit)="save()">
  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-card-title>
        <h2>Packaging Configuration</h2>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="setting">
        <mat-checkbox formControlName="showEFC">{{ displaySettingLabel }}</mat-checkbox>
        <p class="setting-description">Shows this amount above the net price estimate. Students see the change as soon as you save.</p>
      </div>

      <section class="rounding" aria-labelledby="rounding-options-heading">
        <h3 id="rounding-options-heading">Rounding Options</h3>
        <div class="rounding-increment">
          <span class="rounding-label" id="rounding-value-label">Round down to</span>
          <mat-form-field class="rounding-value" appearance="outline" subscriptSizing="dynamic">
            <mat-select formControlName="roundingValue" aria-labelledby="rounding-value-label">
              <mat-option [value]="50">50</mat-option>
              <mat-option [value]="100">100</mat-option>
              <mat-option [value]="200">200</mat-option>
              <mat-option [value]="500">500</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <mat-checkbox formControlName="useRounding">Round grants, scholarships, and self-help</mat-checkbox>
        <mat-checkbox formControlName="efcRounding">Round parent and student contribution</mat-checkbox>
      </section>

      @if (state == 'error') {
        <div class="alert alert-warning" role="alert">An error has occurred attempting to save changes</div>
      }

      <div class="config-actions">
        <button mat-flat-button color="primary" type="submit" [disabled]="state != 'modified' && state != 'error'">
          {{ state == 'modified' || state == 'error' ? 'Save Changes' : 'No unsaved changes' }}
        </button>
        <button mat-stroked-button type="button" (click)="cancel()" [disabled]="state != 'modified' && state != 'error'">Cancel</button>
      </div>
    </mat-card-content>
  </mat-card>
</form>
